import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { Reveal, StaggerGroup } from "src/theme/animation";

interface PartnerOrganization {
    id: number;
    name: string;
    short_name: string;
    slug: string;
    logo: string | null;
    logo_dark: string | null;
    logo_icon: string | null;
    logo_icon_dark: string | null;
}

const ORGANIZATION_RESPONSE: PartnerOrganization[] = [
    /* {
        id: 14,
        name: "Dewey Academy",
        short_name: "Dewey",
        slug: "Dewey",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/Dewey_Mascot_Apr_2012_GyybhAF.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/Dewey_Mascot_Apr_2012.png",
        logo_icon_dark: null,
    },
    */
    {
        id: 9,
        name: "East Bay School",
        short_name: "EBS",
        slug: "EBS",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/ebs.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/ebs-icon.png",
        logo_icon_dark: null,
    },
    {
        id: 7,
        name: "Half Moon Bay High School",
        short_name: "Half Moon Bay",
        slug: "halfmoonbay",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/halfmoonbay_v6lY3FT.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/halfmoonbay_ZWVZa5A.png",
        logo_icon_dark: null,
    },
    {
        id: 6,
        name: "Julia Morgan School for Girls",
        short_name: "Julia Morgan",
        slug: "juliamorgan",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/JM_.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/JM_.png",
        logo_icon_dark: null,
    },
    {
        id: 12,
        name: "Marin Volleyball Club",
        short_name: "Marvin VB",
        slug: "marinvb",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/marvinvb.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/marvinvb-logo.png",
        logo_icon_dark: null,
    },
    {
        id: 10,
        name: "The Permanente Medical Group",
        short_name: "TPMG",
        slug: "TPMG",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/gen-thrive.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/tpmg_logo.png",
        logo_icon_dark: null,
    },
    {
        id: 8,
        name: "ThermAvant Technologies",
        short_name: "ThermAvant",
        slug: "TATeers",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/thermavant-text-black.png",
        logo_dark: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/thermavant-text-white.png",
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/thermavant-icon.png",
        logo_icon_dark: null,
    },
    {
        id: 13,
        name: "Urban Alchemy",
        short_name: "UA",
        slug: "ua",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/urban-alchemy_m8ICPNk.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/urban-alchemy_l1eRQK6.png",
        logo_icon_dark: null,
    },
    {
        id: -1,
        name: " Behavior Health Department - Alameda County Health",
        short_name: "Alameda County Health",
        slug: "alamedahealth",
        logo: "https://webapp.strongmindstrongperformance.com/images/partners/alameda-county-health.png",
        logo_dark: null,
        logo_icon: "https://webapp.strongmindstrongperformance.com/images/partners/alameda-county-health.png",
        logo_icon_dark: null,
    }, {
        id: 5,
        name: "Beachside High School",
        short_name: "Beachside",
        slug: "beachside",
        logo: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/beachside-hs-logo.png",
        logo_dark: null,
        logo_icon: "https://storage.googleapis.com/strongmsp-media/media/organization_logos/beachside-hs-logo.png",
        logo_icon_dark: null,
    }
];

/**
 * Partner logo grid matching the Squarespace homepage "OUR PARTNERS" section.
 */
const OurPartners: React.FC = () => {
    return (
        <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: "#fff" }}>
            <Container maxWidth="lg">
                <Reveal variant="fadeUp">
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            textAlign: "center",
                            mb: { xs: 4, md: 5 },
                            fontWeight: 800,
                            letterSpacing: 0.5,
                            textTransform: "uppercase",
                            color: "#202020"
                        }}
                    >
                        Our Partners
                    </Typography>
                </Reveal>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        spacing: 4,
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 8
                    }}
                >
                    <StaggerGroup stagger={0.05}>
                        {ORGANIZATION_RESPONSE.map((org, index) => (
                            <Reveal key={org.id} variant="fadeIn" staggerIndex={index}>
                                <Box
                                    component="img"
                                    src={org.logo ?? org.logo_icon ?? undefined}
                                    alt={org.name}
                                    sx={{
                                        maxWidth: "100%",
                                        maxHeight: { xs: 72, md: 88 },
                                        width: "auto",
                                        height: "auto",
                                        objectFit: "contain"
                                    }}
                                />
                            </Reveal>
                        ))}
                    </StaggerGroup>
                </Box>
            </Container>
        </Box>
    );
};

export default OurPartners;
